import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_583_1110691)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00008 2.00002C4.68637 2.00002 2.00008 4.68631 2.00008 8.00002C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 8.00002C14.0001 4.68631 11.3138 2.00002 8.00008 2.00002ZM0.666748 8.00002C0.666748 3.94993 3.94999 0.666687 8.00008 0.666687C12.0502 0.666687 15.3334 3.94993 15.3334 8.00002C15.3334 12.0501 12.0502 15.3334 8.00008 15.3334C3.94999 15.3334 0.666748 12.0501 0.666748 8.00002ZM7.33342 5.33335C7.33342 4.96516 7.63189 4.66669 8.00008 4.66669H8.00675C8.37494 4.66669 8.67342 4.96516 8.67342 5.33335C8.67342 5.70154 8.37494 6.00002 8.00675 6.00002H8.00008C7.63189 6.00002 7.33342 5.70154 7.33342 5.33335ZM8.00008 7.33335C8.36827 7.33335 8.66675 7.63183 8.66675 8.00002V10.6667C8.66675 11.0349 8.36827 11.3334 8.00008 11.3334C7.63189 11.3334 7.33342 11.0349 7.33342 10.6667V8.00002C7.33342 7.63183 7.63189 7.33335 8.00008 7.33335Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_583_1110691",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgInfo;
